var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"txt_adult"},[_c('span',{staticClass:"txt_inner"},[_vm._v(" "+_vm._s(_vm.$t('required_adult_authentication').split('\n')[0])),_c('br'),_vm._v(" "+_vm._s(_vm.$t('required_adult_authentication').split('\n')[1])+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }